import { Card, CardActions, CardContent, Grid } from '@mui/material';
import React from 'react';
import RadiologyIcon from '../../../../images/appicons/RadiologyIcon.png';
import { useMyProfileQuery } from '../../../../services/profileService/profile-api';


function RadiologyCard(){
    const {data} = useMyProfileQuery();
    const canAccess=():boolean=>{
        if(data?.role === 'Admin'){
            return true;
        }
        if(data?.claimsAccess.find(p => p.code === 'RadRequest') != undefined){
            return true;
        }
        return false;
    }


    return (
        <React.Fragment>
            {canAccess() &&
            <Grid item sm={3}>
            <Card className='card-img-body center-align'>
                <CardContent className='card-img-main'>
                    <a className='btn img-button' href={'/RadMain'}><img className='card-img' src={RadiologyIcon} alt=''/></a>
                </CardContent>
                <CardActions className='card-img-footer'><h6>Radiology Requests</h6></CardActions>
            </Card>
            </Grid>
            }
        </React.Fragment>
    )
}

export {RadiologyCard}